export enum PanelIdentifier {
  GENERAL = "GENERAL",
  ATTACHMENTS = "ATTACHMENTS",
  ORGANIZATION = "ORGANIZATION",
  REMINDER = "REMINDER",
  PUBLISHING = "PUBLISHING",
  DANGER_ZONE = "DANGER_ZONE",
}
